import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import cn from 'classnames'
import {checkedCategoriesIdsSelector, anyQuestionIsLoadingSelector, categoriesCursorSelector, categoriesTreeMapSelector} from '../../../modules/categories'
import {questionsByCategorySelector, createNewForm, sortQuestionsCB, questionNewFormByCategorySelector, checkAndUploadGeneralStatistic} from '../../../modules/questions'

import { animateScroll } from 'react-scroll'
import {getCoords, sortCB} from '../../../helpers/common'
import Loader from '../../common/Loader'
import Questions from "./Questions"
import QuestionsPagination from "./QuestionsPagination"
import QuestionForm from './QuestionForm'
import {CLICK_MULTIPLE_CHOICE, handleSetTutorialStep, tutorialModeSelector} from "../../../modules/tutorial"
import { showModal, MODAL_FORM_QBM } from '../../../modules/modals'
import { sourcesCursorSelector } from '../../../modules/sources'
import { currentSubjectSelector } from '../../../modules/subjects'
import {cloneDeep} from 'lodash';
import { isTeacherOrganisationSelector } from '../../../modules/profile'
import Spiner from '../../helpers/Spiner/Spiner'
import { getLabels } from './QuestionForm/components/Labels/actions'


class QbmBody extends Component {
    render() {
        const {newForm, showNewForm, showTopButton, showBottomButton, buttonIsActive} = this.props
        return (
            <div className="question-container" style={{overflow: 'hidden'}} ref={this.getQuestionContainerRef}>
                {
                    this.renderLoader()
                }
                {
                    showTopButton && (
                        <div className="question-types-block">
                            <div
                                ref={this.getTopButtonRef}
                                onClick={this.handleCreateNewForm}
                                className={cn("question-type", {disabled : !buttonIsActive})}
                            >
                                <span className="question-type-plus-icon">+</span> {this.context.formatMessage("Multiple choice")}
                            </div>
                        </div>
                    )
                }

                {
                    // this.props.questions
                    //     .sort(sortQuestionsCB)
                    //     .map(({id}) => (
                    //         <QuestionForm
                    //             key = {id}
                    //             questionId = {id}
                    //         />
                    //     ))
                }

                    <QuestionsPagination>
                    {/* {
                        showNewForm &&
                        <QuestionForm ref = {this.getNewFormRef} questionId = {newForm.id} />
                    } */}
                    </QuestionsPagination>

                
                {
                    showBottomButton && (
                        <div className="question-types-block">
                            <div
                                onClick={this.handleCreateNewForm}
                                className={cn("question-type", {disabled : !buttonIsActive})}
                            >
                                <span className="question-type-plus-icon">+</span> {this.context.formatMessage("Multiple choice")}
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }

    getQuestionContainerRef = ref => this.questionContainerRef = ref
    getTopButtonRef = ref => this.topButtonRef = ref

    componentDidMount() {
        this.handleTutorial()
        this.props.checkAndUploadGeneralStatistic(true);
        this.props.getLabels();
    }

    componentDidUpdate(prevProps) {
        const {newForm : currNewForm, questionsLength} = this.props
        const {newForm : prevNewForm} = prevProps
        if (!!currNewForm !== !!prevNewForm && questionsLength) this.handleScroll()

        this.handleTutorial()
    }

    handleScroll = () => {
        if (this.newFormNode) {
            const {top : scrollTop} = getCoords(this.newFormNode)
            animateScroll.scrollTo(scrollTop, {
                duration: 1500,
                delay: 100,
                smooth: true,
            })
        }
    }
    handleCreateNewForm = () => {
        const {buttonIsActive, createNewForm} = this.props
        if (!buttonIsActive) return
        const {showModal, initData} = this.props;
        showModal({
            modalType: MODAL_FORM_QBM,
            modalProps: {
                initialValues: cloneDeep(initData)
            }
        })
    }
    getNewFormRef = ref => {
        if (ref) {
            window.__newFromNode = this.newFormNode = findDOMNode(ref)
        }
    }

    renderLoader = () => {
        const {loading} = this.props
        return (loading) &&  <div style={{position: 'absolute', display: 'flex', justifyContent: 'center', width: '100%', height: '100%', background: 'rgba(255,255,255, 0.5)'}}>
            <div style={{height: 'calc(100vh - 130px)', width: 200, position: 'fixed'}}>
                <Spiner />
            </div>
        </div>
    }

    handleTutorial = () => {
        const {handleSetTutorialStep, tutorialModeIsOn} = this.props
        if (tutorialModeIsOn) {
            handleSetTutorialStep({
                step : CLICK_MULTIPLE_CHOICE,
                container : this.questionContainerRef,
                target : this.topButtonRef,
            })
        }
    }

    componentWillUnmount() {
        const {handleSetTutorialStep} = this.props
        handleSetTutorialStep({
            step : CLICK_MULTIPLE_CHOICE,
            container : null,
            target : null,
        })
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const checkedCategoriesIds = checkedCategoriesIdsSelector(state)
        const questions = questionsByCategorySelector(state, checkedCategoriesIds)
        const newForm = questionNewFormByCategorySelector(state, checkedCategoriesIds)
        let showTopButton = true // !!questions.length || newForm
        let showBottomButton = !!questions.length || newForm // true

        const permission =  state.profile.permission || {};
        const isTeacherOrganisation = isTeacherOrganisationSelector(state);

        if(isTeacherOrganisation && !permission.add_new_question){
            showTopButton = false;
            showBottomButton = false;
        }

        const buttonIsActive = checkedCategoriesIds.length && !newForm
        const showNewForm = !!checkedCategoriesIds.length && newForm
        const loading = anyQuestionIsLoadingSelector(state)

        const categoryCursor = categoriesCursorSelector(state)
        const sourceCursor = sourcesCursorSelector(state)
        
        const subjectCursor = currentSubjectSelector(state)
        const categoriesTree = Object.values(categoriesTreeMapSelector(state, checkedCategoriesIds))
        let firstCategory = categoriesTree.sort(sortCB)[0];
        let initData = {
            "category_id": "",
            "subcategory_id": "",
            "subject_id": "",
            "source_id": null,
            "question": "",
            "description": "",
            "answ_state": 1,
            "token": '',
            "difficulty": 0,
            "expl_state": 1,
            "status": 2,
            "answerT1": {
              "correct_answer": "",
              "answer_1": "",
              "answer_2": "",
              "answer_3": "",
              "answer_4": "",
              "answer_5": "",
              "answer_6": "",
              "answer_7": "",
              "answer_8": "",
              "answer_9": "",
              "answer_10": ""
            },
        };
        if(sourceCursor){
            initData.source_id = sourceCursor;
        }

       

        if(subjectCursor){
            initData.subject_id = subjectCursor.id;
        }

        if (firstCategory) {
            const {id : _category_id, subcategories} = firstCategory;
            initData.category_id = _category_id.replace('cat_', '');
            const _subcat = subcategories.find(subcat => subcat.id === categoryCursor)
            if (_subcat) {
                initData.subcategory_id = _subcat.id.replace('subcat_', '')
            } 
        }




        return {
            questions, // TODO temp for testing react virtualized
            questionsLength : questions.length,
            newForm,
            showTopButton,
            initData,
            showBottomButton,
            buttonIsActive,
            showNewForm,
            loading,
            tutorialModeIsOn : tutorialModeSelector(state)
        }
    },
    {
        createNewForm, 
        showModal,
        handleSetTutorialStep,
        getLabels,
        checkAndUploadGeneralStatistic
    }
)(QbmBody)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/index.js